export const getDefaultValues = (gatewayProfileDetails) => ({
  GatewayProfileApplicationID: gatewayProfileDetails?.GatewayProfileApplicationID || 0,
  GatewayProfileLabel: gatewayProfileDetails?.GatewayProfileLabel || '',
  GatewayProfilePackageName: gatewayProfileDetails?.GatewayProfilePackageName || '',
  GatewayProfileCallback: gatewayProfileDetails?.GatewayProfileCallback || '',
});
